import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from '../../services/authentication/authentication.service';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { Auth0Controller } from '../../../../common/js/authentication/Auth0Controller';

@Component({
  moduleId: module.id,
  selector: 'logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
  protected getController(): Auth0Controller {
    return this.windowService.nativeWindow.controller;
  }

  constructor(
    protected authenticationService: AuthenticationService,
    protected windowService: WindowService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.logout();
  }

  protected async logout(): Promise<void> {
    await this.authenticationService.preLogout();
    await this.getController().logout();
    await this.windowService.nativeWindow.amorphic.expireController();
    this.authenticationService.routeAfterLogout();
  }
}
